module.exports = __webpack_public_path__ + "assets/img/f9705d37d8cd53e90cd9f77baa75c900.png";